export function scrollToWikiTop() {
  const scrollContainer = document.querySelector<HTMLElement>(
    ".wiki-content-scroll",
  );

  if (scrollContainer) {
    scrollContainer.scrollTop = 0;
  } else {
    window.scrollTo(0, 0);
  }
}
